import { Dentist } from "@/services/dentist-service";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { AlertTriangle } from "lucide-react";

interface DeleteDentistDialogProps {
  dentist: Dentist | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: (id: string) => void;
}

export function DeleteDentistDialog({ dentist, open, onOpenChange, onDelete }: DeleteDentistDialogProps) {
  if (!dentist) return null;

  const handleDelete = () => { onDelete(dentist.id); onOpenChange(false); };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader className="border-b pb-2">
          <DialogTitle className="text-sm font-semibold uppercase tracking-wide flex items-center gap-2 text-destructive">
            <AlertTriangle className="h-4 w-4" />
            Deletar Profissional
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-3 py-2">
          <div className="bg-destructive/10 border border-destructive/20 rounded-lg p-3">
            <p className="text-xs text-destructive font-medium">
              Atenção: Esta ação não pode ser desfeita. Todos os dados do profissional serão permanentemente removidos.
            </p>
          </div>

          <div className="space-y-1">
            <Label className="filter-label">Nome</Label>
            <Input className="filter-input" value={dentist.name} disabled />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1">
              <Label className="filter-label">CPF</Label>
              <Input className="filter-input" value={dentist.cpf} disabled />
            </div>
            <div className="space-y-1">
              <Label className="filter-label">Data de Nascimento</Label>
              <Input className="filter-input" value={dentist.birth_date ? new Date(dentist.birth_date).toLocaleDateString('pt-BR') : ""} disabled />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1">
              <Label className="filter-label">Email</Label>
              <Input className="filter-input" value={dentist.email} disabled />
            </div>
            <div className="space-y-1">
              <Label className="filter-label">Telefone</Label>
              <Input className="filter-input" value={dentist.cellphone} disabled />
            </div>
          </div>

          <div className="space-y-1">
            <Label className="filter-label">CRO</Label>
            <Input className="filter-input" value={dentist.cro} disabled />
          </div>
        </div>

        <div className="flex justify-end gap-2 pt-3 border-t">
          <Button variant="outline" size="sm" className="btn-header" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button variant="destructive" size="sm" className="btn-header" onClick={handleDelete}>Deletar Profissional</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
